/**
 * Checks if any indicator in the graphData has data_type === "percentage"
 * by looking up the indicator in blockDetails using block_id and indicator_id
 * @param graphData - The graph data object containing indicator information
 * @param blockDetails - Array of blocks containing indicator definitions
 * @returns boolean - true if any indicator has data_type === "percentage", false otherwise
 */
const hasPercentageDataType = (graphData: any, blockDetails: any): boolean => {
  if (
    !graphData ||
    !graphData.data ||
    !Array.isArray(graphData.data) ||
    !blockDetails ||
    !Array.isArray(blockDetails)
  ) {
    return false;
  }

  // Check each indicator in graphData
  return graphData.data.some((item: any) => {
    const indicator = item?.indicator;
    if (!indicator || !indicator.block_id || !indicator.indicator_id) {
      return false;
    }

    // Find the block using block_id
    const block = blockDetails.find((blockItem: any) => blockItem.block_id === indicator.block_id);
    if (!block || !block.indicators || !Array.isArray(block.indicators)) {
      return false;
    }

    // Find the indicator within the block using indicator_id
    const foundIndicator = block.indicators.find(
      (ind: any) => ind.indicator_id === indicator.indicator_id,
    );

    // Check if the indicator has data_type === "percentage"
    return foundIndicator?.data_type === 'percentage';
  });
};

export default hasPercentageDataType;
